import Navigation from './Navigation'
import Footer from './Footer'
import ArticleNavigator from '../blog/ArticleNavigator'

interface LayoutProps {
  children: React.ReactNode
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-between bg-[#ddd] antialiased font-sans"
      style={{
        fontFeatureSettings: '"rlig" 1, "calt" 1',
        fontFamily: 'Inter, sans-serif'
      }}
    >
      <Navigation />
      <main className="flex-grow flex items-center justify-center w-full">
        {children}
      </main>
      <ArticleNavigator />
      <Footer />
    </div>
  )
}

export default Layout 
